import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSectionOffsetSizeS from './IconSectionOffset_size_s';

const props: CreateIconArguments = {
  l: IconSectionOffsetSizeS,
  m: IconSectionOffsetSizeS,
  s: IconSectionOffsetSizeS,
  xs: IconSectionOffsetSizeS,
  name: 'IconSectionOffset',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
